const bagActionTypes = {
  ADD_ITEM_TO_BAG: 'ADD_ITEM_TO_BAG',
  REMOVE_BAG_ITEM: 'REMOVE_BAG_ITEM',
  DECREASE_BAG_ITEM: 'DECREASE_BAG_ITEM',
  // GET_BAG_TOTAL: 'GET_BAG_TOTAL',
};

export default bagActionTypes;
